import {
  AnimalCard as AnimalCardType,
  ExtensionType,
} from "backend/src/common/types/ExtensionCard";
import { store } from "store/store";
import { getPlayerAvatar } from "./getPlayerAvatar";

import lizard from "resources/lizardGreen.svg";
import lizardPink from "resources/lizardPink.svg";
import egg from "resources/egg.svg";
import mike from "resources/mike.svg";

const MIKE_NAME = "Mike Wazowski".toLowerCase();

export const getAnimalFallbackImage = (
  card: AnimalCardType,
  extensions: Array<{ visibleType?: ExtensionType; type?: ExtensionType }>,
): string => {
  const getExtensionKind = (extension: {
    visibleType?: ExtensionType;
    type?: ExtensionType;
  }) => extension.visibleType || extension.type || null;

  let imageSrc = lizard;

  if (
    extensions.some((extension) => {
      const extensionKind = getExtensionKind(extension);
      return (
        !!extensionKind &&
        [ExtensionType.poisonous, ExtensionType.pseudoPoisonous].includes(
          extensionKind,
        )
      );
    })
  ) {
    imageSrc = lizardPink;
  }

  if (
    extensions.some(
      (extension) => getExtensionKind(extension) === ExtensionType.egg,
    )
  ) {
    imageSrc = egg;
  }

  if ((card.meta.name || "").toLowerCase() === MIKE_NAME) {
    imageSrc = mike;
  }

  const playerWithSameName = store.players.find(
    (player) =>
      !!player.meta.name &&
      !!card.meta.name &&
      player.meta.name.toLowerCase() === card.meta.name.toLowerCase(),
  );

  if (playerWithSameName) {
    imageSrc = getPlayerAvatar(playerWithSameName);
  }

  return imageSrc;
};
